import { Routes } from '@angular/router';

import { roleGuard } from '../../@core/authentication/guards/role.guard';
import { AccountType } from '../../@core/authentication/models/account-type.enum';
import { profileRoutes } from '../profile/profile.routes';

/**
 * MAKER-only routes. Default landing: maker-queue-list.
 */
export const makerRoleRoutes: Routes = [
  {
    path: 'maker',
    canActivate: [roleGuard(AccountType.MAKER)],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('../dashboard/dashboard-outlet').then((m) => m.DashboardOutlet),
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import(
                '../dashboard/pages/maker-queue-list/maker-queue-list'
              ).then((m) => m.MakerQueueList),
          },
        ],
      },
      {
        path: 'case/:batchId/:caseId',
        loadComponent: () =>
          import(
            '../dashboard/pages/maker-queue-list/maker-queue-details/maker-queue-details'
          ).then((m) => m.MakerQueueDetails),
      },
      ...profileRoutes,
    ],
  },
];
